import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsInlineSkateNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_inline_skate_normal_large_svg__clip0_138_64)">
        <path
          d="M5.25 48a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5zm0-8.5A3.25 3.25 0 112 42.75a3.256 3.256 0 013.25-3.25zm37.5-2a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm0 8.5A3.25 3.25 0 1146 42.75 3.256 3.256 0 0142.75 46zM12.5 42.75a5.25 5.25 0 1010.499 0 5.25 5.25 0 00-10.499 0zm8.5 0a3.25 3.25 0 11-3.25-3.25A3.256 3.256 0 0121 42.75zm4 0a5.25 5.25 0 1010.499 0 5.25 5.25 0 00-10.499 0zm8.5 0a3.25 3.25 0 11-3.25-3.25 3.256 3.256 0 013.25 3.25zM2.78 32.33A7.53 7.53 0 008.53 35h32.24A6.237 6.237 0 0047 28.77a4.818 4.818 0 00-2.55-4.25L21.88 12.45l1.46-7.74A4 4 0 0019.42 0h-3.96l-2 3h-8.3L1.12 26.21a7.535 7.535 0 001.66 6.12zm27.232-13.269l-2.655 5.128a1.5 1.5 0 01-1.334.811 1.499 1.499 0 01-1.334-2.2l2.67-5.155 2.653 1.416zM3.1 26.55l.1-.55h4.87a6.923 6.923 0 016.65 5h2.07a8.934 8.934 0 00-8.72-7H3.54l3.3-19h7.7l2-3h2.88a2 2 0 011.95 2.35L20.87 7H14.5a3.5 3.5 0 100 7h6.04l5.06 2.7-2.682 5.181a3.504 3.504 0 004.168 4.951 3.503 3.503 0 002.051-1.726l2.642-5.1 6.711 3.584L34.65 31h2.25l3.35-6.46 3.26 1.74A2.83 2.83 0 0145 28.77 4.238 4.238 0 0140.77 33H8.53a5.5 5.5 0 01-5.43-6.45zM20.49 9l-.56 3H14.5a1.5 1.5 0 010-3h5.99z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_inline_skate_normal_large_svg__clip0_138_64">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsInlineSkateNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsInlineSkateNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsInlineSkateNormalLarge;
